<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    center
    width="60%"
  >
    <dialog-header
      slot="title"
      :title="
        (!isEdit ? $t('public.create') : $t('public.update')) +
        ' ' +
        $t('geofence.name')
      "
      :icon="!isEdit ? 'icon-dialog-add' : 'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle
      :title="$t('public.baseInfo')"
      :icon-config="{ icon: 'approve-car-info' }"
    >
      <el-form
        v-loading="loading"
        size="mini"
        :model="formInfo"
        label-suffix="："
        ref="baseForm"
        :show-message="false"
        :label-width="$t('geofence.style.formLabelWidth')"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$t('carMonitor.electric.electricNotes.ruleName')"
              prop="ruleName"
              required
            >
              <el-input
                v-model="formInfo.ruleName"
                maxlength="50"
                clearable
                :placeholder="$t('carMonitor.electric.electricNotes.ruleName')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('carMonitor.electric.electricNotes.alarmType')"
              prop="alarmType"
              required
            >
              <el-select
                v-model="formInfo.alarmType"
                :placeholder="$t('carMonitor.electric.electricNotes.alarmType')"
              >
                <el-option
                  v-for="(item, index) in alarmTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- subuser block↓ -->
        <el-row v-if="!isEdit && !isDepartment" :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$t(`carMonitor.electric.electricManage.${subUSerName}`)"
              prop="roleId"
            >
              <el-select
                v-model="formInfo.id"
                :placeholder="
                  $t(`carMonitor.electric.electricManage.${subUSerName}`)
                "
                filterable
                clearable
                @change="clearVehicle"
              >
                <el-option
                  v-for="(item, index) in subUserList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <span class="sub-user-tip"
              >{{ $t("carMonitor.electric.electricManage.subUserTip")
              }}{{
                $t(`carMonitor.electric.electricManage.${subUSerName}`)
              }}</span
            >
          </el-col>
        </el-row>
        <!-- subuser block↑ -->
        <el-row :gutter="10">
          <el-col :span="19">
            <el-form-item
              :label="$t('carMonitor.electric.electricManage.carTitle')"
            >
              <div class="car-border vehicle-tag" style="height: 100px">
                <el-scrollbar
                  style="height: 100%"
                  wrap-class="default-scrollbar__wrap"
                >
                  <el-tag
                    v-for="item in vehicleList"
                    :key="item.carid"
                    closable
                    effect="plain"
                    :disable-transitions="false"
                    @close="removeVehicle(item)"
                  >
                    <vue-licenseplate
                      :licensepalte="item.licensePlate"
                      :area="item.areaName"
                    />
                  </el-tag>
                </el-scrollbar>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" @click="addVehicle">{{
              $t("public.add")
            }}</el-button>
            <el-button type="primary" @click="clearVehicle">{{
              $t("public.clear")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </vue-linetitle>

    <vue-linetitle
      :title="$t('carMonitor.electric.electricManage.wlxx')"
      :icon-config="{ icon: 'approve-mileage-info' }"
    >
      <div>
        <el-form
          inline
          size="mini"
          label-suffix="："
          :label-width="$t('geofence.style.formLabelWidth')"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('carMonitor.electric.electricManage.rulestype')"
              >
                <el-radio v-model="formInfo.ruleType" :label="0">{{
                  $t("geofence.shape.polygon")
                }}</el-radio>
                <el-radio v-model="formInfo.ruleType" :label="1">{{
                  $t("geofence.shape.rectangle")
                }}</el-radio>
                <el-radio v-model="formInfo.ruleType" :label="2">{{
                  $t("geofence.shape.circle")
                }}</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('geofence.mapPoint')"
                :label-width="$t('geofence.style.formLabelWidth2')"
              >
                <el-switch v-model="mapSwitch" @change="switchChange" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" v-show="mapSwitch" @click="reSwitch">{{
                $t("public.reset")
              }}</el-button>
            </el-col>
          </el-row>
          <el-row v-if="formInfo.ruleType == 2">
            <el-col :span="12">
              <el-form-item :label="$t('geofence.centerPosition')">
                <el-input v-model="address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('geofence.radius')">
                <el-input-number
                  :min="10"
                  :precision="0"
                  v-model="shape.radius"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="amap">
          <vue-map
            :map-type-control="true"
            class="loading-map"
            :language="language"
            :zoom="zoom"
            :disable-default-ui="true"
            :center="center"
            :fullscreen-control="true"
            :events="mapEvents"
            :bounds="mapBounds"
          >
            <vue-map-polygon
              ref="shapePolygon"
              v-if="shape.path.length"
              :visible="formInfo.ruleType === 0"
              :path="shape.path"
              :draggable="shape.draggable"
              :editable="shape.editable"
              :stroke-color="shape.strokeColor"
              :stroke-weight="shape.strokeWeight"
              :stroke-opacity="shape.strokeOpacity"
              :fill-color="shape.fillColor"
              :fill-opacity="shape.fillOpacity"
            />
            <vue-map-rectangle
              ref="shapeRectangle"
              v-if="shape.bounds.length === 2"
              :visible="formInfo.ruleType === 1"
              :bounds="shape.bounds"
              :draggable="shape.draggable"
              :editable="shape.editable"
              :stroke-color="shape.strokeColor"
              :stroke-weight="shape.strokeWeight"
              :stroke-opacity="shape.strokeOpacity"
              :fill-color="shape.fillColor"
              :fill-opacity="shape.fillOpacity"
            />
            <vue-map-circle
              ref="shapeCircle"
              v-if="shape.center"
              :visible="formInfo.ruleType === 2"
              :center="shape.center"
              :radius="shape.radius"
              :draggable="shape.draggable"
              :editable="shape.editable"
              :stroke-color="shape.strokeColor"
              :stroke-weight="shape.strokeWeight"
              :stroke-opacity="shape.strokeOpacity"
              :fill-color="shape.fillColor"
              :fill-opacity="shape.fillOpacity"
              :events="shape.circleEvents"
            />
          </vue-map>
        </div>
      </div>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="headleCancel">{{
        $t("public.cancel")
      }}</el-button>
      <el-button type="primary" @click="submitForm">{{
        $t("public.define")
      }}</el-button>
    </span>
    <select-vehicle
      :visible.sync="selectVehicleVisible"
      :is-sub="isSub"
      :sub-id="formInfo.id"
      @select="selectVehicle"
    />
  </el-dialog>
</template>

<script>
import { getUserLanguage } from '@/utils/auth'
// request
import { createUrl, updateUrl, geofencVehicleListUrl, subUserUrl } from '@/api/electric/geofence'
import resolve from '@/api/resolve'

import SelectVehicle from './selectVehicle'
export default {
  components: { SelectVehicle },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ([])
    }
  },
  data() {
    return {
      selectVehicleVisible: false,
      formInfo: {
        ruleName: '',
        alarmType: '0,1',
        ruleType: 2,
        center: []
      },
      vehicleList: [],
      alarmTypeList: [
        { label: this.$t('geofence.out'), value: '0' },
        { label: this.$t('geofence.in'), value: '1' },
        { label: this.$t('geofence.out') + '&' + this.$t('geofence.in'), value: '0,1' }
      ],
      language: getUserLanguage(),
      loading: false,
      // 谷歌地图
      zoom: 15,
      center: [100.530449, 13.722944],
      mapSwitch: true,
      mapEvents: {
        click: (e) => {
          if (this.mapSwitch) {
            if (this.formInfo.ruleType === 2) {
              this.shape.center = [e.latLng.lng(), e.latLng.lat()]
              this.formInfo.center = this.shape.center
              this.address = this.formInfo.center.join(",")
            } else if (this.formInfo.ruleType === 1) {
              const point = [e.latLng.lng(), e.latLng.lat()]
              let bounds = this.shape.bounds
              if (bounds.length > 1) {
                bounds = [bounds[1], point]
              } else {
                bounds.push(point)
              }
              this.shape.bounds = this.correctBounds(bounds)
            } else if (this.formInfo.ruleType === 0) {
              this.shape.path.push([e.latLng.lng(), e.latLng.lat()])
            }
          }
        }
      },
      mapBounds: null,
      shape: {
        // 圆形专用
        center: null,
        radius: 1000,
        // 矩形专用
        bounds: [],
        // 多边形专用
        path: [],
        editable: false,
        draggable: false,
        strokeColor: '#0091ea',
        strokeWeight: 5,
        strokeOpacity: 1,
        fillColor: '#ffff00',
        fillOpacity: 0.5,
        circleEvents: {
          center_changed: () => {
            this.formInfo.center = this.$refs.shapeCircle.$$getCenter()
          },
          radius_changed: () => {
            this.shape.radius = this.$refs.shapeCircle.$$getRadius()
          }
        }
      },
      subUserList: [],
      isSub: false,
      userName: '',
      address: ''
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.isEdit) {
          this.formInfo = { ...this.data }
          if (this.data.ruleType === 0) {
            let minLat = 90,
              maxLat = -90,
              minLng = 180,
              maxLng = -180
            this.shape.path = this.data.ruleParam.split(';').map(p => {
              const point = p.split(',').map(v => +v)
              minLat = Math.min(minLat, point[1])
              maxLat = Math.max(maxLat, point[1])
              minLng = Math.min(minLng, point[0])
              maxLng = Math.max(maxLng, point[0])
              return point
            })
            this.mapBounds = [[minLng, minLat], [maxLng, maxLat]]
          } else if (this.data.ruleType === 1) {
            const points = this.data.ruleParam.split(';').map(p => {
              return p.split(',').map(v => +v)
            })
            this.shape.bounds = [points[0], points[2]]
            this.mapBounds = this.shape.bounds
          } else {
            const params = this.data.ruleParam.split(';')
            const center = params[0].split(',').map(v => +v)
            const radius = +params[1]
            const diff = radius * 0.00001
            this.shape.center = center
            this.shape.radius = radius
            this.formInfo.center = center
            this.address = center.join(",")
            // 1米大约0.00001度
            this.mapBounds = [[center[0] - diff, center[1] - diff], [center[0] + diff, center[1] + diff]]
          }
          this.mapSwitch = false
          this.shape.editable = true
          this.shape.draggable = true
          this.loadGeofenceVehicle()
        } else if (newVal) {
          this.formInfo.id = ""
        }
      },
      immediate: true
    }
  },
  computed: {
    isDepartment() {
      return this.$store.getters.roles[0].roleName === "Department"
    },
    isChannel() {
      return this.$store.getters.roles[0].roleName === "Channel"
    },
    subUSerName() {
      return this.$store.getters.roles[0].roleName === "Company"
        ? "subCompany"
        : this.$store.getters.roles[0].roleName === "Sub Company"
          ? "department"
          : ""
    }
  },
  created() {
    if (!this.isDepartment && !this.isChannel) {
      this._getSubUserList()
    }
  },
  methods: {
    switchChange(newVal) {
      if (newVal) {
        this.shape.editable = false
        this.shape.draggable = false
      } else {
        this.shape.editable = true
        this.shape.draggable = true
      }
    },
    reSwitch() {
      if (this.formInfo.ruleType === 0) {
        this.shape.path = []
      } else if (this.formInfo.ruleType === 1) {
        this.shape.bounds = []
      } else {
        this.shape.center = null
        this.formInfo.center = []
      }
    },
    addVehicle() {
      if (!this.isEdit && !this.formInfo.id && !this.isDepartment) {
        this.$confirm(this.$t('carMonitor.electric.electricManage.addVehicleTip'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define'),
          cancelButtonText: this.$t('public.cancel'),
          type: 'warning'
        }).then(() => {
          this.isSub = false
          this.selectVehicleVisible = true
        })
      } else if(this.isDepartment || !this.formInfo.id){
        this.isSub = false
        this.selectVehicleVisible = true
      } else {
        this.isSub = true
        this.selectVehicleVisible = true
      }
    },
    clearVehicle() {
      this.vehicleList = []
    },
    selectVehicle(vehicleList) {
      vehicleList.forEach(v => {
        if (this.vehicleList.findIndex(i => i.carId === v.carId) < 0) {
          this.vehicleList.push(v)
        }
      })
    },
    removeVehicle(item) {
      this.vehicleList.splice(this.vehicleList.indexOf(item), 1)
    },
    // 关闭dialog
    closeDialog() {
      this.$emit('update:visible', false)
      this.reset()
    },
    reset() {
      this.formInfo.ruleName = ''
      this.formInfo.ruleType = 2
      this.formInfo.alarmType = '0,1'
      this.formInfo.center = []
      this.shape.center = null
      this.shape.path = []
      this.shape.bounds = []
      this.mapSwitch = true
      this.shape.editable = false
      this.shape.draggable = false
      this.vehicleList = []
      this.address = ''
    },
    loadGeofenceVehicle() {
      this.loading = true
      this.$http.post(resolve(geofencVehicleListUrl, this.data.ruleId)).then(({ data }) => {
        this.vehicleList = data.data || []
      }).catch(() => {
        this.closeDialog()
        this.$message.error(this.$t('public.formLoadFailed'))
      }).finally(() => {
        this.loading = false
      })
    },
    // 点击取消
    headleCancel() {
      this.closeDialog()
    },
    correctBounds(bounds) {
      const p1 = bounds[0]
      const p2 = bounds[1]
      if (p1 && p2 && p1[0] > p2[0]) {
        return [p2, p1]
      }
      return bounds
    },
    // 新增
    _geofenceAdd(postData) {
      this.$http.post(createUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _geofenceUpdate(postData) {
      this.$http.put(resolve(updateUrl, this.data.ruleId), postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    },
    // 点击提交
    submitForm() {
      this.$refs.baseForm.validate((valid) => {
        if (valid) {
          let ruleParam
          const { ruleName, alarmType, ruleType, id } = this.formInfo
          if (ruleType === 0) {
            if (this.shape.path.length < 3) {
              this.$message.warning({
                message: this.$t('geofence.shape.warning.polygon'),
                duration: 2 * 1000
              })
              return
            } else {
              ruleParam = this.$refs.shapePolygon.$$getPath().map(p => `${p[0]},${p[1]}`).join(';')
            }
          } else if (ruleType === 1) {
            if (this.shape.bounds.length != 2) {
              this.$message.warning({
                message: this.$t('geofence.shape.warning.rectangle'),
                duration: 2 * 1000
              })
              return
            } else {
              const bounds = this.$refs.shapeRectangle.$$getBounds()
              const minLng = Math.min(bounds[0][0], bounds[1][0])
              const minLat = Math.min(bounds[0][1], bounds[1][1])
              const maxLng = Math.max(bounds[0][0], bounds[1][0])
              const maxLat = Math.max(bounds[0][1], bounds[1][1])
              ruleParam = `${minLng},${maxLat};${maxLng},${maxLat};${maxLng},${minLat};${minLng},${minLat}`
            }
          } else {
            if (this.address) {
              this.formInfo.center = this.address.split(",")
              this.shape.center = this.formInfo.center
            }
            if (!this.shape.center) {
              this.$message.warning({
                message: this.$t('geofence.shape.warning.circle'),
                duration: 2 * 1000
              })
              return
            } else {
              ruleParam = `${this.formInfo.center.join(',')};${this.shape.radius}`
            }
          }
          const postData = {
            ruleName,
            alarmType,
            ruleType,
            ruleParam,
            id,
            carIdList: this.vehicleList.map(v => v.carId)
          }
          if (!this.isEdit) {
            this._geofenceAdd(postData)
          } else {
            this._geofenceUpdate(postData)
          }
        }
      })
    },
    _getSubUserList() {
      this.$http.post(subUserUrl).then(({ data }) => {
        if (data.code === 0) {
          this.subUserList = data.data || []
        }
      })
    }
  }
}

</script>
<style lang="scss">
* {
  font-style: normal;
}
.amap {
  height: 48vh;
  width: 100%;
  margin-bottom: 10px;
  position: relative;
}
.wl-flex-p {
  display: flex;
  span {
    flex: 1;
  }
}
.car-border {
  border: 1px dashed #ddd;
  flex: 1;
  padding: 5px;
  .permanent {
    margin: 5px;
  }
}
.red {
  color: #ff0000;
}
.blue {
  color: #409eff;
}
.vehicle-tag {
  .el-tag {
    border: 0;
    background-color: transparent;
    margin: 8px 0;
    padding: 0;
    .el-icon-close {
      right: 7px;
    }
  }
}
.sub-user-tip {
  display: inline-block;
  padding: 8px 0 0 15px;
  color: red;
  word-break: break-word;
}
</style>
